import { render, staticRenderFns } from "./SplashCarousel.vue?vue&type=template&id=1ed65484&scoped=true&"
import script from "./SplashCarousel.vue?vue&type=script&lang=js&"
export * from "./SplashCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SplashCarousel.vue?vue&type=style&index=0&id=1ed65484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed65484",
  null
  
)

export default component.exports